export const manifest = {
  screens: {
    scr_1f5evc: { name: "Home", route: "/" },
  },
}
